import {
  InspectorFillColourBlock,
  InspectorFillOpacityBlock,
  InspectorFillStrokeChannels,
  InspectorKeyframeTable,
  InspectorLayerKeyframeSource,
  InspectorLayerTransformSelect,
  InspectorRawSelectionJson,
  InspectorSelectionHeader,
  InspectorStrokeColourBlock,
  InspectorStrokeOpacityBlock,
  InspectorStrokeWidthBlock,
  InspectorTextFillColour,
} from "@shared/components/animationPlayground/inspectorSections";
import { useAnimationInspector } from "@shared/components/animationPlayground/useAnimationInspector";

export interface InspectorPanelProps {
  animationData: unknown;
  selectedPathKey: string | null;
  onCommitAnimation: (nextRoot: unknown) => void;
}

export default function InspectorPanel({ animationData, selectedPathKey, onCommitAnimation }: InspectorPanelProps) {
  const ins = useAnimationInspector({ animationData, onCommitAnimation, selectedPathKey });

  return (
    <div className="flex flex-col gap-4" data-testid="animation-playground-inspector">
      <p className="text-xs font-medium uppercase tracking-wide text-zinc-500">Inspector</p>

      {!ins.selectedRow ? (
        <p className="text-xs text-zinc-500">Select a layer or shape item in the composition list.</p>
      ) : (
        <>
          <InspectorSelectionHeader row={ins.selectedRow} />
          <InspectorLayerKeyframeSource ins={ins} />
          <InspectorLayerTransformSelect ins={ins} />
          <InspectorTextFillColour ins={ins} />
          <InspectorFillStrokeChannels ins={ins} />
          <InspectorFillColourBlock ins={ins} />
          <InspectorFillOpacityBlock ins={ins} />
          <InspectorStrokeColourBlock ins={ins} />
          <InspectorStrokeWidthBlock ins={ins} />
          <InspectorStrokeOpacityBlock ins={ins} />
          {ins.keyframeTarget ? <InspectorKeyframeTable label={ins.keyframeTarget.label} rows={ins.keyframes} /> : null}
          {ins.selectedRow.kind !== "layer" && ins.selectedRow.kind !== "fill" && ins.selectedRow.kind !== "stroke" ? (
            <InspectorRawSelectionJson node={ins.node} />
          ) : null}
        </>
      )}
    </div>
  );
}
